import React from 'react';

export const Route404 = () => {
    return (
        <div className="404">
            Uh-oh, this page does not exist!
      </div>
    )
}